// Full-document render of the cocoon UtilityPage: PageSkeleton (the React
// document shell) wrapping the utility body.
import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { UtilityPageBody } from "../components/UtilityPageBody";

export const Template = (
    props: Immutable<templates.UtilityPageTemplate>,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <UtilityPageBody page={props.page} />
    </PageSkeleton>
);
